import React from "react";
import { AlertCircle, X } from "lucide-react";

// A form-level alert that stays pinned to the top of the scroll area, so a
// validation/save error is visible no matter how far down a long form the user
// has scrolled. Drop it in as the first child of the page's content wrapper:
//
//   <FormAlert message={error} onDismiss={() => setError(null)} />
//
// Renders nothing when `message` is falsy.
const TONES = {
  error: "bg-red-50 border-red-200 text-red-800",
  warning: "bg-amber-50 border-amber-200 text-amber-800",
  success: "bg-emerald-50 border-emerald-200 text-emerald-800",
  info: "bg-blue-50 border-blue-200 text-blue-800",
};

export default function FormAlert({ message, onDismiss, tone = "error" }) {
  if (!message) return null;

  return (
    <div className="sticky top-0 z-30 pt-2 pb-4 bg-background">
      <div
        role="alert"
        className={`flex items-start gap-2 rounded-lg border px-4 py-3 text-sm shadow-md ${
          TONES[tone] || TONES.error
        }`}
      >
        <AlertCircle className="h-4 w-4 shrink-0 mt-0.5" strokeWidth={2} />
        <div className="flex-1 break-words">{message}</div>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Dismiss"
            className="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>
    </div>
  );
}
